import { useState, useEffect } from 'react';
import { SCROLL_THRESHOLD_PX } from '../views/landing/constants/animation';

export const useScrollThreshold = (threshold: number = SCROLL_THRESHOLD_PX) => {
  const [isAboveThreshold, setIsAboveThreshold] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsAboveThreshold(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return { isAboveThreshold };
};
